import React, { Component } from 'react';
import _ from 'lodash';

import * as programmeController from '../../../../services/api/programme';
import FilterGroup from '../../../../components/FilterGroup/FilterGroup';
import ProgrammeList from './components/ProgrammeList/ProgrammeList';

export class ProgrammePage extends Component {
    constructor(props) {
        super(props);

        this.state = {
        	courseCodes: [],
            programmeCategories: [],
            centers: [],
            institutes: [],
            filters: {},
            searchText: ''
        }
    }

    fetchCourseCode() {
        programmeController.getCourseCodes()
            .then((res) => res.json())
            .then((json) => this.setState({ courseCodes: json }))
    }

    fetchProgrammeCategory() {
        programmeController.getProgrammeCategories()
            .then((res) => res.json())
            .then((json) => this.setState({ programmeCategories: json }))
    }

    fetchCenter() {
        programmeController.getCenters()
            .then((res) => res.json())
            .then((json) => this.setState({ centers: json }))
    }

    fetchInstitue() {
        programmeController.getInstitutes()
            .then((res) => res.json())
            .then((json) => this.setState({ institutes: json }))
    }

    componentDidMount() {
    	this.fetchCourseCode();
        this.fetchProgrammeCategory();
        this.fetchCenter();
        this.fetchInstitue();
    }

    render() {
        const { courseCodes, programmeCategories, centers, institutes, filters, searchText } = this.state;
        const statusOptions = ['Opening for Application', 'Closed for Application', 'Ended', 'Inactive'];
        const filterList = [{
            type: 'select',
            name: 'course_codes',
            placeholder: 'Course',
            options: _.map(courseCodes, (courseCode) => ({ label: courseCode.name, value: courseCode.name }))
        }, {
            type: 'select',
            name: 'programme_category',
            placeholder: 'Category',
            options: _.map(programmeCategories, (programmeCategory) => ({ label: programmeCategory.name, value: programmeCategory.name }))
        }, {
            type: 'select',
            name: 'center',
            placeholder: 'Center',
            options: _.map(centers, (center) => ({ label: center.name, value: center.name }))
        }, {
            type: 'select',
            name: 'institute',
            placeholder: 'Institute',
            options: _.map(institutes, (institute) => ({ label: institute.name, value: institute.name }))
        }, {
            type: 'select',
        	name: 'status',
        	placeholder: 'Status',
        	options: _.map(statusOptions, (status) => ({ label: status, value: status }))
        }];

        return (
            <div className="ProgrammePage ListPage">
            	<div className="page-header">
            		<h2>Programme</h2>
					<FilterGroup
						filterList={filterList}
						onChange={(filters, searchText) => this.setState({ filters, searchText })}
					/>
            	</div>
            	<ProgrammeList
            		filters={filters}
            		searchText={searchText}
            	/>
			</div>
        );
    }
}

export default ProgrammePage;


// WEBPACK FOOTER //
// ./src/scenes/DashboardPage/scenes/ProgrammePage/ProgrammePage.js